import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('trash.invoices_received_short'),
      path: 'trash/invoicesreceived',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'trash/invoicesreceived/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'trash/invoicesreceived/historical',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
